var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{staticClass:"member-tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"active-tab":_vm.$route.fullPath},on:{"click":_vm.activateTab}}),_vm._t("default")],2):_c('div',{staticClass:"full-height-error"},[_c('Error',{attrs:{"message":null,"code":403}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }